import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../../../../../API";
import { isAutheticated } from "../../../../auth/authhelper";
import Footer from "../../../Footer";

function Products(props) {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(null); // For specific actions
  const { token } = isAutheticated();
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [showData, setShowData] = useState(featuredProducts);

  const getFeatureData = async (page = 1, size = 10) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${API}/api/feature_product/view_featured_products?page=${page}&size=${size}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setFeaturedProducts(res.data.data);
    } catch (error) {
      console.error("Error fetching featured products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFeatureData();
  }, [token]);
  //pagination
  useEffect(() => {
    const loadData = () => {
      const indexOfLastPost = currentPage * itemPerPage;
      const indexOfFirstPost = indexOfLastPost - itemPerPage;
      setShowData(featuredProducts.slice(indexOfFirstPost, indexOfLastPost));
    };

    loadData();
  }, [featuredProducts, currentPage, itemPerPage]);
  //
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Do you want to delete this product?");
    if (!confirmDelete) return;

    setActionLoading(id);
    try {
      await axios.delete(`${API}/api/feature_product/delete_feature_product/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFeaturedProducts((prev) => prev.filter((product) => product._id !== id));
    } catch (error) {
      console.error("Error deleting product:", error);
    } finally {
      setActionLoading(null);
    }
  };

  const ChangeStatusHandler = async (id) => {
    setActionLoading(id);
    try {
      await axios.get(`${API}/api/feature_product/change_status/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFeaturedProducts((prev) =>
        prev.map((product) =>
          product._id === id ? { ...product, status: product.status === "active" ? "inactive" : "active" } : product
        )
      );
    } catch (error) {
      console.error("Error changing product status:", error);
    } finally {
      setActionLoading(null);
    }
  };

  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* Page title */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Commerce - Featured Products</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">SoComOTT</Link>
                    </li>
                    <li className="breadcrumb-item">Commerce - Featured Products</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* Featured Products Table */}
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="row ml-0 mr-0 mb-10">
                    <div className="col-sm-12 col-md-6"></div>
                    <div className="col-sm-12 col-md-6">
                      <div className="dropdown d-block">
                        <Link to="/add/feature/product">
                          <button
                            type="button"
                            className="btn btn-primary add-btn waves-effect waves-light float-right"
                          >
                            <i className="fa fa-plus" aria-hidden="true"></i> Add Featured Product
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>


                  <div className="table-responsive table-shoot">
                    <table className="table table-centered table-nowrap mb-0">
                      <thead className="thead-light">
                        <tr>
                          <th>Thumbnail</th>
                          <th>Product Name</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="10" align="center" style={{ padding: "20px" }}>
                              <div style={{ fontSize: "1.3rem", fontWeight: "bold", color: "#007bff" }}>
                                Loading...
                              </div>
                            </td>
                          </tr>
                        ) : showData?.length > 0 ? (
                          showData.map((feature) => (
                            <tr key={feature._id}>
                              <td>
                                <img
                                  src={feature.feautred_image}
                                  width="110"
                                  height="60"
                                  alt="Product Thumbnail"
                                />
                              </td>
                              <td>{feature.feautred_product?.title}</td>
                              <td>
                                <span className={`badge badge-pill font-size-12 ${feature.status === "active" ? "badge-success" : "badge-danger"
                                  }`}>
                                  {feature.status === "active" ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td>
                                <button
                                  onClick={() => ChangeStatusHandler(feature._id)}
                                  disabled={actionLoading === feature._id}
                                  className="btn btn-success btn-sm waves-effect waves-light btn-table"
                                >
                                  {actionLoading === feature._id ? "Processing..." : feature.status === "active" ? "Make Inactive" : "Make Active"}
                                </button>
                                <Link
                                  to={`/edit/feature/product/${feature._id}`}
                                  className="btn btn-primary btn-sm waves-effect waves-light btn-table ml-2"
                                >
                                  Edit
                                </Link>
                                <button
                                  onClick={() => handleDelete(feature._id)}
                                  disabled={actionLoading === feature._id}
                                  className="btn btn-danger btn-sm waves-effect waves-light btn-table ml-2"
                                >
                                  {actionLoading === feature._id ? "Deleting..." : "Delete"}
                                </button>
                              </td>
                            </tr>
                          ))) : (
                          <tr>
                            <td colSpan="10" align="center" style={{ padding: "20px" }}>
                              <div style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#ff0000" }}>
                                No Feature Product Found. Please add New Feature product to display here.
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div className='row mt-20'>
                    <div className='col-sm-12 col-md-6 mb-20'>
                      <div
                        className='dataTables_info'
                        id='datatable_info'
                        role='status'
                        aria-live='polite'>
                        Showing {currentPage * itemPerPage - itemPerPage + 1} to{" "}
                        {Math.min(currentPage * itemPerPage, featuredProducts?.length)} of{" "}
                        {featuredProducts?.length} entries
                      </div>
                    </div>

                    <div className='col-sm-12 col-md-6'>
                      <div className='dataTables_paginate paging_simple_numbers float-right'>
                        <ul className='pagination'>
                          <li
                            className={
                              currentPage === 1
                                ? "paginate_button page-item previous disabled"
                                : "paginate_button page-item previous"
                            }>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='0'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev - 1)
                              }>
                              Previous
                            </a>
                          </li>

                          {!(currentPage - 1 < 1) && (
                            <li className='paginate_button page-item'>
                              <a
                                aria-controls='datatable'
                                data-dt-idx='1'
                                tabIndex='0'
                                className='page-link'
                                onClick={(e) =>
                                  setCurrentPage((prev) => prev - 1)
                                }>
                                {currentPage - 1}
                              </a>
                            </li>
                          )}

                          <li className='paginate_button page-item active'>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='2'
                              tabIndex='0'
                              className='page-link'>
                              {currentPage}
                            </a>
                          </li>

                          {!(
                            (currentPage + 1) * itemPerPage - itemPerPage >
                            featuredProducts?.length
                          ) && (
                              <li className='paginate_button page-item '>
                                <a
                                  href='#'
                                  aria-controls='datatable'
                                  data-dt-idx='3'
                                  tabIndex='0'
                                  className='page-link'
                                  onClick={() => {
                                    setCurrentPage((prev) => prev + 1);
                                  }}>
                                  {currentPage + 1}
                                </a>
                              </li>
                            )}

                          <li
                            className={
                              !(
                                (currentPage + 1) * itemPerPage - itemPerPage >
                                featuredProducts?.length
                              )
                                ? "paginate_button page-item next"
                                : "paginate_button page-item next disabled"
                            }>
                            <a
                              href='#'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev + 1)
                              }>
                              Next
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/*  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Products;
